import React, { useState, useContext } from 'react'
import { useHistory } from 'react-router-dom'
import PropTypes from 'prop-types'
import cn from 'classnames'
import Grid from '../Grid'
import Image from '../Image'
import Typography from '../Typography'
import styles from './PackageItem.module.sass'
import { CustomerContext } from '../../contexts/CustomerContext'
import OrderPackage from '../../models/OrderPackage'
import useLocalStorage from '../../hooks/useLocalStorage'
import preorderIcon from '../../assets/preorder.png'

// `overlay` is the student's poses composited into the card art (sport
// pricelists only — see PackageSelection). It has to share a containing block
// with the image ITSELF, not with the grid cell: the slots are percentages of
// the artwork, and .itemImg is padded and capped at 60% width on desktop, so
// positioning them against the cell would shift and scale every one of them.
// Hence the two wrappers below. No overlay passed → the original markup.
const PackageItem = ({ packageItem: { id, bannerUrl, name, useNewPackageBuilder, imageUrl },
                       to,renderPlaceholder = false, currentSeason, overlay = null }
) => {
  const { customer, setCustomer } = useContext(CustomerContext)
  const [display, setDisplay] = useState(styles.hidden)
  const history = useHistory()
  const [isUsingAccessCode] = useLocalStorage('isUsingAccessCode')

  const handleSelection = () => {
    // The cart is created asynchronously (CustomerContext); if a card is clicked
    // before it resolves, don't throw on customer.cart.id — ignore the click and let
    // the user retry once the cart exists.
    if (!customer.cart) return

    const orderPackage = new OrderPackage({
      packageId: id,
      cartId: customer.cart.id,
      isPreviewHidden: !isUsingAccessCode,
    })

    setCustomer({ ...customer, currentOrderPackage: orderPackage })
    history.push(to)
  }

  return (
    <Grid
      item
      container
      xs={11}
      classes={cn(styles.packageItem, display, { [styles.whiteBg]: !useNewPackageBuilder })}
      onClick={handleSelection}
    >
      {renderPlaceholder ? (
        <Image classes={styles.itemImg} src={preorderIcon} onLoad={() => setDisplay(undefined)} />

      ) : (
        useNewPackageBuilder ? (
          overlay ? (
            <div className={styles.overlayOuter}>
              <div className={styles.overlayWrap}>
                <Image classes={styles.overlayImg} src={bannerUrl} onLoad={() => setDisplay(undefined)} />
                {overlay}
              </div>
            </div>
          ) : (
            <Image classes={styles.itemImg} src={bannerUrl} onLoad={() => setDisplay(undefined)} />
          )
        ) : (
          <>
            <Grid item xs={2}>
              <Image classes={styles.itemImg} src={imageUrl} onLoad={() => setDisplay(undefined)} />
            </Grid>
            <Grid container alignItems="center" item xs={10}>
              <Typography weight={600} classes={styles.typography}>{name}</Typography>
            </Grid>
          </>
        )
      )}
    </Grid>
  )
}

PackageItem.propTypes = {
  packageItem: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    imageUrl: PropTypes.string.isRequired,
    isSeniorPortraits: PropTypes.bool.isRequired,
  }).isRequired,
  to: PropTypes.string.isRequired,
}

export default PackageItem
